import { Button, Group, Stack } from '@mantine/core';
import { modals } from '@mantine/modals';
import { i18nKeys, useTranslation } from 'locales';
import type { Thread } from 'modules/Mails/hooks';
import type { LightThread } from 'modules/Mails/hooks/use-load-mails';
import type { PropsWithChildren } from 'react';
import {
  ExternalMailActionFormProvider,
  type ExternalMailActionFormValues,
  useExternalMailActionForm,
} from './form-context';

type ExternalMailActionProps = {
  onSubmit: (values: ExternalMailActionFormValues) => void;
  mail: Thread | LightThread;
};

export const ExternalMailAction = ({
  onSubmit,
  mail,
  children,
}: PropsWithChildren<ExternalMailActionProps>) => {
  const { t } = useTranslation();

  const form = useExternalMailActionForm({
    initialValues: {
      id: mail.id,
      debtorId: mail.debtor?.id ?? null,
      userId: mail.accountManager?.id?.toString() ?? null,
      debtor: mail.debtor ?? null,
    },
  });

  return (
    <ExternalMailActionFormProvider form={form}>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Stack p="md" gap="sm">
          {children}
          <Group justify="end">
            <Button variant="outline" onClick={() => modals.closeAll()} mt="xs">
              {t(i18nKeys.CANCEL)}
            </Button>
            <Button disabled={!form.isDirty()} type="submit" mt="xs">
              {t(i18nKeys.SAVE)}
            </Button>
          </Group>
        </Stack>
      </form>
    </ExternalMailActionFormProvider>
  );
};
